import { render, staticRenderFns } from "./PricingManagement.vue?vue&type=template&id=08eeb4ca&scoped=true"
import script from "./PricingManagement.vue?vue&type=script&lang=js"
export * from "./PricingManagement.vue?vue&type=script&lang=js"
import style0 from "./PricingManagement.vue?vue&type=style&index=0&id=08eeb4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eeb4ca",
  null
  
)

export default component.exports